export const SET_CACHEABLES_STATE = 'cachables/SET_CACHEABLES_STATE'
